module.exports = __webpack_public_path__ + "static/media/species_upset.7d9edf2c.png";